// utils/format.js
export const INR = (n, withSymbol = true) => {
  const num = Number(n || 0);
  if (withSymbol) return "₹ " + num.toLocaleString("en-IN");
  return num.toLocaleString("en-IN");
};

export const fmtDate = (d) => {
  if (!d) return "—";
  const date = new Date(d);
  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const fmtDateTime = (d) => {
  if (!d) return "—";
  const date = new Date(d);
  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};
